<template>
  <main>
    <div class="page-content">
   <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
               <h4 class="mb-0 font-size-18">Dashboard</h4>
               <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                     <li class="breadcrumb-item"><a href="javascript: void(0);">Your Servers</a></li>
                     <li class="breadcrumb-item active">Dashboard</li>
                  </ol>
               </div>
            </div>
         </div>
      </div>
      <!-- end page title -->
      <div class="row">
         <div class="col-xl-4">
            <div class="card">
               <div class="card-body border-bottom">
                  <div class="float-right dropdown ml-2">
                     <a class="text-muted dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                     <i class="mdi mdi-dots-horizontal font-size-18"></i>
                     </a>
                     <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="#">Reinstall Server</a>
                        <a class="dropdown-item" href="#">Delete Server</a>
                     </div>
                  </div>
                  <div>
                     <div class="mb-3 mr-3">
                        <i class="bx bxs-rocket text-primary h1"></i>
                     </div>
                     <div>
                        <h4 class="">Your Server Information</h4>
                        <p class="text-muted mb-1">IP Address: duckyserver.spc.mn</p>
                        <p class="text-muted mb-1">Player Slots: 2</p>
                        <p class="text-muted mb-1">Tier: <span class="badge badge-success">FREE</span></p>
                     </div>
                  </div>
               </div>
               <div class="card-body border-bottom">
                  <div>
                     <div class="row">
                        <div class="col-sm-6">
                           <div>
                              <p class="text-muted mb-2">Server Actions</p>
                              <div class="col-md-6">
                                <div class="btn-group" role="group" aria-label="Basic example">
                                   <button type="button" class="btn btn-light" v-on:click="sendStatusAction('start')" :disabled="status == 'online' || status == 'loading'">Start</button>
                                   <button type="button" class="btn btn-light" v-on:click="sendStatusAction('stop')" :disabled="status == 'offline' || status == 'loading'">Stop</button>
                                   <button type="button" class="btn btn-light" v-on:click="sendStatusAction('restart')">Restart</button>
                                </div>
                              </div>
                           </div>
                        </div>
                        <div class="col-sm-6">
                           <div class="text-sm-right mt-4 mt-sm-0">
                              <p class="text-muted mb-2">Server Not Responding?</p>
                              <button type="button" class="btn btn-danger waves-effect btn-label waves-light" data-toggle="modal" data-target="#myModal"><i class="bx bx-error label-icon "></i> Kill Server</button>
                           </div>
                           <div id="myModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                              <div class="modal-dialog">
                                 <div class="modal-content">
                                    <div class="modal-header">
                                       <h5 class="modal-title mt-0" id="myModalLabel">WARNING!</h5>
                                       <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                       <span aria-hidden="true">&times;</span>
                                       </button>
                                    </div>
                                    <div class="modal-body">
                                       <h5>Kill Server</h5>
                                       <p>Doing this may cause irreversible corruption to your server files. Do not use this function unless your server is not responding.</p>
                                    </div>
                                    <div class="modal-footer">
                                       <button type="button" class="btn btn-secondary waves-effect" data-dismiss="modal">Cancel</button>
                                       <button type="button" class="btn btn-danger waves-effect waves-light">Kill Server</button>
                                    </div>
                                 </div>
                                 <!-- /.modal-content -->
                              </div>
                              <!-- /.modal-dialog -->
                           </div>
                           <!-- /.modal -->
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="col-xl-8">
            <div class="row">
               <div class="col-sm-4">
                  <div class="card mini-stats-wid">
                     <div class="card-body">
                        <div class="media">
                           <div class="mr-3 align-self-center">
                              <i class="bx bxs-chip h2 text-primary mb-0"></i>
                           </div>
                           <div class="media-body">
                              <p class="text-muted mb-2">CPU Usage</p>
                              <h5 class="mb-0">{{ usage.cpu }}% <span class="font-size-14 text-muted"></span></h5>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-sm-4">
                  <div class="card mini-stats-wid">
                     <div class="card-body">
                        <div class="media">
                           <div class="mr-3 align-self-center">
                              <i class="bx bxs-ruler h2 text-primary mb-0"></i>
                           </div>
                           <div class="media-body">
                              <p class="text-muted mb-2">RAM Usage</p>
                              <h5 class="mb-0">{{ usage.ram }}MB <span class="font-size-14 text-muted">/ {{ usage.maxRam }}MB</span></h5>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-sm-4">
                  <div class="card mini-stats-wid">
                     <div class="card-body">
                        <div class="media">
                           <div class="mr-3 align-self-center">
                              <i class="bx bxs-user h2 text-primary mb-0"></i>
                           </div>
                           <div class="media-body">
                              <p class="text-muted mb-2">Players Online</p>
                              <h5 class="mb-0">{{ usage.players }} <span class="font-size-14 text-muted">/ {{ usage.maxPlayers }}</span></h5>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <!-- end row -->
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Resource Management Graphs</h4>
                  <div>
                     <div id="overview-chart" class="apex-charts" dir="ltr"></div>
                     <apexchart width="500" :options="options" :series="series"></apexchart>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- end row -->
      <!-- end row -->
   </div>
   <!-- container-fluid -->
</div>
  </main>
</template>

<script>
export default {
  name: 'Dashboard',
  data: function () {
    return {
      status: 'loading',
      options: {
        chart: {
          type: 'area',
          id: 'vuechart-example'
        },
        xaxis: {
          categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
        }
      },
      usage: {
        cpu: 0,
        ram: 0,
        maxRam: 0,
        players: 0,
        maxPlayers: 0
      },
      series: [{
        name: 'CPU',
        data: [30, 40, 45, 50, 49, 60, 70, 91]
      }, {
        name: 'RAM',
        data: [5, 5, 5, 5, 5, 5, 5, 5]
      }]
    }
  },
  methods: {
    sendStatusAction: function (action) {
      if (!['start', 'stop', 'restart', 'kill'].includes(action)) return
      this.$socket.emit('status:action', action)
    }
  },
  mounted () {
    this.$socket.emit('server:status')
  },
  sockets: {
    'server:status': function (data) {
      console.log(status)
      this.status = data
    },
    'server:usage': function (data) {
      console.log(data)
      if(data.hasOwnProperty('cpu')) this.usage.cpu = data.cpu
      if(data.hasOwnProperty('ramUsed')) this.usage.ram = data.ramUsed
      if(data.hasOwnProperty('ramMax')) this.usage.maxRam = data.ramMax
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/panel/Dashboard.vue